import * as ExcelJS from "exceljs";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { currencyFormat } from "../../../utils/currencyFormat";
import { getTransactionNames } from "src/components/extractPdf";
import transactionLabel from "src/utils/transactionLabel";
import { ExtractItem } from "src/utils/extractDescription";
import groupTransactionsByDate from "src/utils/groupTransactionsByDate";
import moment from "moment";
import toLocaleAmount from "src/utils/toLocaleAmount";
import { documentFormatted } from "src/utils/documentFormatted";
import axios from "axios";

const dateFormat = (date: string | undefined): string => {
  const formattedDate = format(new Date(date || ""), "dd/MM/yyyy HH:mm", {
    locale: ptBR,
  });
  return formattedDate;
};

export default async function handleExportExcel(
  items: ExtractItem[],
  account: {
    name: string;
    branch: string;
    number: string;
    document: string;
    type: "MEMBER" | "GRAPHIC";
    numberIdentifier: string;
    isBackoffice?: boolean;
  },
  backoffice?: boolean
) {
  const token = window.localStorage.getItem(
    !backoffice ? "@stricv2:token" : "@backoffice:token"
  );
  const data = groupTransactionsByDate(items);

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/transactions/daily-final-balances`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const dailyBalances = response.data[0]?.dailyBalances?.map(
      (balance: { amount: number; createdAt: string }) => {
        return {
          amount: balance.amount,
          createdAt: moment(balance.createdAt.split("T")[0]).format(
            "DD/MM/YYYY"
          ),
        };
      }
    );

    const update_date = data.map((item) => {
      const matchedDaily = dailyBalances?.find(
        (daily: { createdAt: string }) => daily.createdAt === item.date
      );

      const amount = matchedDaily ? matchedDaily.amount : 0;

      return {
        ...item,
        dayly_amount: amount,
      };
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Extrato");

    // Definindo largura das colunas
    const columnA = worksheet.getColumn("A");
    const columnB = worksheet.getColumn("B");
    const columnC = worksheet.getColumn("C");
    const columnD = worksheet.getColumn("D");
    const columnE = worksheet.getColumn("E");
    columnA.width = 30;
    columnB.width = 30;
    columnC.width = 65;
    columnD.width = 20;
    columnE.width = 35;

    worksheet.columns.forEach((column) => {
      column.alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    });

    // Adicionando logo na primeira linha
    const imageId = workbook.addImage({
      base64:
        "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",
      extension: "png",
    });

    const imageWidth = 250;
    const imageHeight = 50;

    worksheet.addImage(imageId, {
      tl: { col: 0.6, row: 0.5 },
      ext: { width: imageWidth, height: imageHeight },
    });

    worksheet.properties.defaultRowHeight = 30;

    worksheet.mergeCells("A1:B2");

    worksheet.getCell("C1").value = account.name;
    if (account.type == "MEMBER")
      worksheet.getCell("C2").value = `Agência: ${
        account.type == "MEMBER" ? account.branch : ""
      }`;

    worksheet.mergeCells("D1:E1");
    worksheet.mergeCells("D2:E2");

    worksheet.getCell("D1").value = documentFormatted(account.document);

    worksheet.getCell("D2").value = `CONTA: ${
      account.type == "MEMBER" ? account.number : account.numberIdentifier
    }`;

    worksheet
      .addRow(["Data", "Tipo", "Beneficiário / Pagador", "Descrição", "Valor"])
      .eachCell((cell) => {
        cell.font = {
          size: 16,
          color: { argb: "AA7339" },
          name: "Calibri",
          scheme: "minor",
          bold: true,
          family: 2,
        };
      });

    update_date.forEach((groupedTransactions, index) => {
      worksheet
        .addRow([
          `Entradas: R$ ${toLocaleAmount(groupedTransactions.in)}`,
          `Saídas: R$ ${toLocaleAmount(groupedTransactions.out)}`,
          `Saldo do dia: ${groupedTransactions.date}`,
          "",
          `R$ ${toLocaleAmount(groupedTransactions.dayly_amount)}`,
        ])
        .eachCell((cell) => {
          cell.font = {
            size: cell.address.includes("C") ? 14 : 12,
            color: { argb: "000000" },
            name: "Calibri",
            scheme: "minor",
            bold: true,
            family: 2,
          };
        });

      groupedTransactions.transactions.forEach((item, index) => {
        if (item.status == "done") {
          const names = getTransactionNames(item);

          worksheet
            .addRow([
              dateFormat(item.created_at),
              item.direction === "in" ? "Crédito" : "Débito",
              item.direction == "in"
                ? `De ${names.payerName}`
                : `Para ${names.beneficiaryName}`,
              transactionLabel(item),
              `${item.direction == "in" ? "+" : "-"} ${currencyFormat(
                Number(item.amount)
              )}`,
            ])
            .eachCell((cell) => {
              if (cell.address.includes("E")) {
                cell.font = {
                  color:
                    item.direction == "in"
                      ? { argb: "4AD858" }
                      : { argb: "B92100" },
                };
              }
            });
        }
      });
    });

    // Escrevendo o arquivo Excel e criando o link para download
    const excelBlob = await workbook.xlsx.writeBuffer();
    const blob = new Blob([excelBlob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    // Defina um nome de arquivo válido
    const fileName = "extrato.xlsx";
    a.download = fileName;

    // Acione o download
    a.click();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
